import { fork } from 'redux-saga/effects';

import api from '~apis/index';

import auth from './auth';
import dashboard from './dashboard';
import customer from './customer';
import gold from './gold';
import branch from './branch';
import setting from './setting';
import admin from './admin';
import approval from './approval';
import discount from './discount';

import { SagaForkReturnType } from '~types/saga';
import project from './project';
import silver from './silver';
import report from './report';
import customerTransfer from './customerTransfer';

const apiInstance = api;

export default function* root(): SagaForkReturnType {
    yield fork(auth(apiInstance.auth, apiInstance.admin).rootSaga);
    yield fork(dashboard(apiInstance.dashboard).rootSaga);
    yield fork(customer(apiInstance.customer, apiInstance.approval).rootSaga);
    yield fork(gold(apiInstance.gold, apiInstance.approval).rootSaga);
    yield fork(branch(apiInstance.branch).rootSaga);
    yield fork(setting(apiInstance.setting).rootSaga);
    yield fork(admin(apiInstance.admin).rootSaga);
    yield fork(approval(apiInstance.approval, apiInstance.gold, apiInstance.discount, apiInstance.customer, apiInstance.branch, apiInstance.customerTransfer).rootSaga);
    yield fork(discount(apiInstance.discount).rootSaga);
    yield fork(project(apiInstance.project).rootSaga);
    yield fork(silver(apiInstance.silver).rootSaga);
    yield fork(report(apiInstance.report).rootSaga);
    yield fork(customerTransfer(apiInstance.customerTransfer).rootSaga);
}
